// const axios = require('axios')
import axios from 'axios';

const createHandler = (method) => {
  console.log("check")
  return async function (url, body, headers = {}) {
    const config = {
      method,
      url,
      data: body,
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
        ...headers,
      },
    }
    try {
      const response = await axios(config)
      return response.data
    } catch (error) {
      console.log(error)
      // throw new Error(JSON.stringify(error.response));
      return error.response
    }
  }
}

const httpHandler = {
  get: createHandler('get'),
  post: createHandler('post'),
  put: createHandler('put'),
  patch: createHandler('patch'),
}

export default httpHandler
